import React, {useEffect, useState} from 'react';
import Button from '@mui/material/Button';

import {translations} from 'presentation/translations-new';
import Icon from 'presentation/icons';
import {Loading} from 'presentation/components/Loading/Loading';
import {CounterButtonProps} from './types';

const {resendToken} = translations['pt-br'].publicFlow.actionText;
const {wait} = translations['pt-br'].publicFlow.resendToken;

export function CounterButton({handleAction, isSubmitting}: CounterButtonProps) {
	const INITAL_COUNTER_IN_SECONDS = 120;

	const [counter, setCounter] = useState(INITAL_COUNTER_IN_SECONDS);
	const [buttonText, setButtonText] = useState('');
	const isDisabled = counter !== 0 || isSubmitting;
	const minutes = Math.floor(counter / 60);
	const seconds = minutes === 0 ? counter : counter % 60;

	const loadingIcon = isSubmitting ? <Loading color="inherit" size={16} /> : null;

	useEffect(() => {
		if (counter > 0) {
			const timer = setInterval(() => setCounter(value => value - 1), 1000);

			if (counter >= 60) {
				setButtonText(`${wait} ${minutes}m ${seconds}s`);
			} else {
				setButtonText(`${wait} ${seconds}s`);
			}
			return () => clearInterval(timer);
		}
		return setButtonText(resendToken);
	});

	return (
		<Button
			fullWidth
			disabled={isDisabled}
			size="large"
			type="submit"
			onClick={handleAction}
			endIcon={isDisabled ? loadingIcon : <Icon name="reload" />}>
			{buttonText}
		</Button>
	);
}
